export default "__VITE_ASSET__Bf5pYXJC__"